"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeOptions = exports.styleOptions = exports.prizeTypeOptions = exports.prizeTypeMaps = exports.prizeItemPicMap = exports.prizeItem = exports.formRules = exports.defaultTypeDataMap = exports.defaultStyleDataMap = exports.defaultFormData = void 0;
var typeOptions = exports.typeOptions = [{
  label: '定时开奖',
  value: 2
}, {
  label: '即抽即中',
  value: 1
}];
var styleOptions = exports.styleOptions = [
// { label: '转盘抽奖', value: 1, disabled: true },
// { label: '幸运福袋', value: 2, disabled: true },
// { label: '惊喜盲盒', value: 3, disabled: true },
{
  label: '幸运九宫格',
  value: 4,
  disabled: false
},
// { label: '天天抽红包', value: 5, disabled: false },
{
  label: '定时抽红包',
  value: 6,
  disabled: false
}];
var defaultFormData = exports.defaultFormData = {
  activityType: 2,
  activityName: '',
  // 活动名称
  activityStyle: 6,
  // 活动样式
  activityCoverPic: '',
  activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
  // 活动背景图
  activityLimitTime: 1,
  drawTime: [],
  // 活动时间 开始+结束，纯前端字段，后续需要转换为开始时间和结束时间
  drawStartTime: '',
  // 开始时间
  drawEndTime: '',
  // 结束时间
  winTime: '',
  // 开奖时间
  remark: '',
  // 活动说明
  validityDate: 24,
  // 兑奖有效期(X小时)
  indexFlag: 0,
  // 是否展示在首页
  advId: '',
  // 广告id
  qrcodeId: '',
  // 客服二维码id
  popupDes: '',
  // 客服按钮文案
  prizeDes: '',
  // winsPic: '', // 中奖结果图片
  joinType: 1,
  // 参与条件(1=不限,2=消耗积分)
  joinCostPoints: 0,
  // 消耗积分数量
  dailyLimit: 0,
  // 每人每日抽奖总次数
  initUserNum: 100,
  // 初始参与人数
  replyId: '',
  replyIds: [],
  prizeSaveRequest: [],
  sort: 0
};
var defaultTypeDataMap = exports.defaultTypeDataMap = {
  1: {
    activityStyle: 4,
    activityLimitTime: 1,
    activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
    remark: '点击“开始”开始转动，最终停下的即为您所中的奖品。',
    joinType: 2,
    __extra__: {
      joinTypeOptions: [{
        label: '消耗积分',
        value: 2,
        disabled: false
      }]
    }
  },
  2: {
    activityStyle: 6,
    activityLimitTime: 1,
    activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
    remark: '点击“开始”开始转动，最终停下的即为您所中的奖品。',
    joinType: 1,
    __extra__: {
      joinTypeOptions: [{
        label: '立即参与',
        value: 1,
        disabled: false
      }, {
        label: '看广告参与',
        value: 3,
        disabled: true
      }, {
        label: '加客服参与',
        value: 4,
        disabled: true
      }]
    }
  }
};
var defaultStyleDataMap = exports.defaultStyleDataMap = {
  4: {
    activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
    remark: '点击“开始”开始转动，最终停下的即为您所中的奖品。'
  },
  5: {
    activityBackPic: '/crmebimage/presets/wheel/lottery_grid_bg.png',
    remark: '点击“开始”开始转动，最终停下的即为您所中的奖品。'
  }
};
var prizeItem = exports.prizeItem = {
  awardName: '',
  // 奖项名称
  prizeName: '',
  // 奖品名称
  prizeType: 4,
  // 奖品类型（1:积分;2:实物;3:红包;4:商城商品;99:未中奖）
  pointsValue: 1,
  // 赠送积分值
  prizeNum: 1,
  // 奖品数量
  price: 100,
  // 实物奖品价格
  prizeTitle: '',
  prizeSubTitle: '',
  productId: '',
  productName: '',
  productOtPrice: '',
  grantMethod: 1,
  // 发放方式 1平均
  validityDate: 24,
  // 兑奖有效期(X小时)
  prizePic: '',
  // 奖品图片
  redPacketPrice: 1,
  // 红包奖品金额
  ruleDes: '',
  // 规则说明
  winFlag: 0,
  winProbability: 0,
  // 中奖概率（百分比）
  redemptionRule: '前往「专属活动商城页面」购买任一商品，即可解锁奖品福利，完成购买后。奖品与您购买的商品一起发货。',
  // 兑奖规则
  userWinLimit: 1,
  // 奖品每人可中奖次数
  redirectUrl: '',
  // 跳转链接
  sort: 0 // 排序
};
var prizeItemPicMap = exports.prizeItemPicMap = {
  0: '/crmebimage/presets/wheel/prize-default.png',
  // 奖品图
  99: '/crmebimage/presets/wheel/prize-empty.png' // 谢谢参与图
};
var prizeTypeOptions = exports.prizeTypeOptions = [{
  label: '积分',
  value: 1
}, {
  label: '实物',
  value: 2
}, {
  label: '红包',
  value: 3
}, {
  label: '商城商品',
  value: 4
}, {
  label: '谢谢参与',
  value: 99
}];
var prizeTypeMaps = exports.prizeTypeMaps = {
  6: [{
    label: '积分',
    value: 1
  }, {
    label: '实物',
    value: 2
  }, {
    label: '红包',
    value: 3
  }, {
    label: '商城商品',
    value: 4
  }],
  4: [{
    label: '积分',
    value: 1
  }, {
    label: '实物',
    value: 2
  }, {
    label: '红包',
    value: 3
  }, {
    label: '商城商品',
    value: 4
  }, {
    label: '谢谢参与',
    value: 99
  }]
};
var formRules = exports.formRules = {
  activityName: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入活动名称'
  }],
  drawTime: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动时间'
  }],
  winTime: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择开奖时间'
  }],
  joinCostPoints: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入消耗积分数量'
  }],
  dailyLimit: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入抽奖次数'
  }],
  activityCoverPic: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动封面图'
  }],
  activityBackPic: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动背景图'
  }],
  qrcodeId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择客服'
  }],
  popupDes: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入客服按钮文案'
  }],
  validityDate: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写兑奖有效期'
  }],
  // winsPic: [{ required: true, trigger: ['blur', 'change'], message: '请选择中奖图' }],
  sort: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入排序值'
  }],
  prizeDes: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请填写奖品说明'
  }]
};